var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { GeoJSON } from "ol/format";
import { defaults as intdefaults, Select } from "ol/interaction";
import { Tile, Vector } from "ol/layer";
// import { Vector } from "ol/layer";
import Map from "ol/Map";
import { TileWMS, Vector as VectorSource } from "ol/source";
import { Fill, Stroke, Style, Text } from "ol/style";
import View from "ol/View";
import { transform } from "ol/proj";
import { Control, } from "ol/control";
import { saveAs } from "file-saver";
/* css styles */
import "./css/ol.css";
import { BCGMS_API_URL, curr_lang, currentCrop, currentIndicator, currentRa, currentReferencial, getCurrentProvider, getCurrentYear, getCurrentDoy, getIndicatorDescription, getRegionAgricoleLabel, getYearMin, hideLoaderBox, INDICATORS_PARAMS, referenceDate, REGIONS_AGRICOLES, resetGeneralGraph, setCurrentRa, setInfoBox, setMessageBox, setReferenceDate, setStatusBox, showLoaderBox, showVariabilitySelector, statusContent, } from "./tools_02";
import { computeReferencialValues, generalGraph, itemGraph, loadDataForItemGraph, loadDataForMapAndGraph, parseIndicatorResults, parseStatsResults, } from "./graph_02";
import { GREENS, BLUES, RED2BLUE, BROWN2GREEN } from "./constants_02";
export var currentMaxValue;
export var currentMinValue;
var interactionSelect;
// let legendLayer;
export var map;
var parcelsTileLayer;
var raLayer;
export var raSource;
export var switchWms = document.getElementById("switchWms");
var addLegendGraphicWms = function (rsIndice) {
    var legendContainer = (document.getElementById("scalebar-container"));
    hideScaleBar();
    // const canvasLegend = <HTMLElement>document.getElementById("scalebar");
    // canvasLegend.classList.add("d-none");
    var url = "https://maps.vito.be/geoserver/BCGMS/ows?service=WMS&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=".concat(rsIndice, "_CROPPED_MASKED");
    var wmsLegend = legendContainer.getElementsByTagName("img");
    if (wmsLegend.length === 1) {
        wmsLegend[0].src = url;
    }
    else {
        var legendImgWrapper = document.createElement("div");
        legendImgWrapper.classList.add("vito-scale-wrapper");
        var legendImg = document.createElement("img");
        legendImg.src = url;
        legendImgWrapper.appendChild(legendImg);
        legendContainer.appendChild(legendImgWrapper);
    }
    legendContainer.classList.add("vito-scale");
};
var addVitoWmsLayer = function (rsIndice, date) {
    removeVitoWmsLayers();
    map.addLayer(makeVitoWmsLayer(rsIndice, date));
};
// function classSelectedToBaseLayerButton(index: number): void {
//   let addParcelsButton = document.getElementById("addParcelsButton");
//   let addOSMButton = document.getElementById("addOSMButton");
//   let addSatOSMButton = document.getElementById("addSatOSMButton");
//   let buttons: Array<HTMLElement> = [
//     addParcelsButton!,
//     addOSMButton!,
//     addSatOSMButton!,
//   ];
//   classSelectedToButton(buttons, index);
// }
// function classSelectedToButton(
//   buttons: Array<HTMLElement>,
//   index: number
// ): void {
//   buttons.forEach((button) => button.classList.remove("selected"));
//   buttons[index].classList.add("selected");
// }
var displaySelectedFeature = function (feature) {
    if (getCurrentProvider() != "FCST") {
        generalGraph.classList.add("d-none");
        // const itemGraph = <HTMLElement>document.getElementById("itemGraph");
        itemGraph.classList.remove("d-none");
        showVariabilitySelector();
        setCurrentRa(feature.get("ra_id"));
        loadDataForItemGraph(currentIndicator, currentRa);
    }
};
var ExportToPngControl = /** @class */ (function (_super) {
    __extends(ExportToPngControl, _super);
    /**
     * @param {Object} [opt_options] Control options.
     */
    function ExportToPngControl(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var button = document.createElement("button");
        button.innerHTML = '<i class="fas fa-file-image"></i>';
        var element = document.createElement("div");
        element.className = "ol-export-png ol-unselectable ol-control";
        element.appendChild(button);
        _this = _super.call(this, {
            element: element,
            target: options.target,
        }) || this;
        button.addEventListener("click", _this.exportMapToPng.bind(_this), false);
        return _this;
    }
    ExportToPngControl.prototype.exportMapToPng = function () {
        var marginleft = 40;
        var marginbottom = 70;
        map.once("postcompose", function (event) {
            // let canvas = event.context.canvas as HTMLCanvasElement;
            var canvas = document.querySelector("div.map canvas");
            /** merge map and legend */
            var context = canvas.getContext("2d");
            var legcanvas = document.getElementById("scalebar");
            var legcontext = legcanvas.getContext("2d");
            var legImage = legcontext.getImageData(0, 0, legcanvas.width, legcanvas.height);
            // // if transparent background, colour it in white
            // for (let i = 0; i < legImage.data.length; i += 4) {
            //   if (legImage.data[i + 3] < 180) {
            //     legImage.data[i] = 255;
            //     legImage.data[i + 1] = 255;
            //     legImage.data[i + 2] = 255;
            //     legImage.data[i + 3] = 255;
            //   }
            // }
            context.putImageData(legImage, marginleft, canvas.height - legcanvas.height - marginbottom);
            /** end merge map and legend */
            /* FOR IE but it does not compile in typescript */
            // if (navigator.msSaveBlob) {
            //   navigator.msSaveBlob(canvas.msToBlob(), `map_${currentIndicator}.png`);
            // } else {
            canvas.toBlob(function (blob) {
                saveAs(blob, "map_".concat(currentIndicator, ".png"));
            });
            // }
        });
        map.renderSync();
    };
    return ExportToPngControl;
}(Control));
var fadeInRegionAgricolelayer = function () {
    map.getLayers().forEach(function (l) {
        if (l.get("title") === "Agricultural regions") {
            l.setStyle(getRegionAgricoleStyle);
        }
    });
};
var fadeOutRegionAgricolelayer = function () {
    map.getLayers().forEach(function (l) {
        if (l.get("title") === "Agricultural regions") {
            l.setStyle([
                new Style({
                    stroke: new Stroke({
                        color: "rgba( 155, 155, 155, 0.8 )",
                        width: 2,
                    }),
                    fill: new Fill({ color: "rgba( 255, 255, 255, 0.5 )" }),
                }),
            ]);
        }
    });
};
var getColor = function (value, minValue, maxValue, palette) {
    var red, green, blue, color;
    //Compute the ratio between the @temparture and its place between the min and max value and set it on a 1 base.
    var ratio = (255 - Math.floor(((value - minValue) / (maxValue - minValue)) * 255)) /
        255;
    //Set color according the color theme
    switch (palette) {
        case "yellow2red":
        default:
            red = 255;
            green = ratio * 255;
            blue = 0;
            color = "rgba( ".concat(red, ", ").concat(green, ", ").concat(blue, ", 1 )");
            break;
        case "greens":
            color = GREENS[Math.round(ratio * GREENS.length) - 1];
            break;
        case "blues":
            color = BLUES[Math.round(ratio * BLUES.length) - 1];
            break;
        case "red2blue":
            color = RED2BLUE[Math.round(ratio * RED2BLUE.length) - 1];
            break;
        case "brown2green":
            color = BROWN2GREEN[Math.round(ratio * BROWN2GREEN.length) - 1];
            break;
    }
    return color;
};
var getColorFromFeature = function (feature) {
    var _a, _b;
    var minValue = (_a = setRoundedMinValue(currentMinValue)) !== null && _a !== void 0 ? _a : INDICATORS_PARAMS[currentIndicator].min_value;
    var maxValue = (_b = setRoundedMaxValue(currentMaxValue)) !== null && _b !== void 0 ? _b : INDICATORS_PARAMS[currentIndicator].max_value;
    var palette = "";
    switch (currentReferencial) {
        case "rel":
            palette = "brown2green";
            break;
        case "abs":
        default:
            palette = INDICATORS_PARAMS[currentIndicator].palette;
            break;
    }
    var value = feature.get("indicator");
    return value === null
        ? "rgba( 200, 200, 200, 1 )" // in case there is a null value
        : getColor(value, minValue, maxValue, palette);
};
var getFontSize = function (feature, resolution) {
    var minFontSize = 10;
    var maxFontSize = 26;
    var area = feature.getGeometry().getArea() / 1e6;
    var ratio = area / resolution;
    return ratio < minFontSize
        ? minFontSize
        : ratio > maxFontSize
            ? maxFontSize
            : ratio;
};
/*
 * Get the largest polygon of the multipolygons collection
 * @param {string} polygons - polygon geometry object
 */
var getLargestPolygon = function (polygons) {
    var polyObj = [];
    for (var b = 0; b < polygons.length; b++) {
        polyObj.push({ poly: polygons[b], area: polygons[b].getArea() });
    }
    polyObj.sort(function (a, b) {
        return a.area - b.area;
    });
    return polyObj[polyObj.length - 1].poly;
};
var getRegionAgricoleLabelStyle = function (feature, resolution) {
    return new Style({
        // Style for the labels (only the largest polygon is labelled)
        text: new Text({
            font: "".concat(getFontSize(feature, resolution), "px sans-serif"),
            text: getText(feature, resolution),
            overflow: true,
            fill: new Fill({ color: "black" }),
            stroke: new Stroke({ color: "white", width: 2 }),
        }),
        geometry: getLargestPolygon(feature.getGeometry().getPolygons()).getInteriorPoint(),
    });
};
var getRegionAgricoleStyle = function (feature, resolution, selected) {
    if (selected === void 0) { selected = false; }
    return [
        new Style({
            // Style for the polygons
            stroke: new Stroke({
                color: "rgba( 155, 155, 155, 0.8 )",
                width: selected ? 6 : 2,
            }),
            fill: new Fill({ color: getColorFromFeature(feature) }),
        }),
        getRegionAgricoleLabelStyle(feature, resolution),
    ];
};
export var getSelectInteraction = function (map) {
    var select;
    map.getInteractions().forEach(function (i) {
        if (i instanceof Select) {
            select = i;
        }
    });
    return select;
};
var getText = function (feature, _resolution) {
    return getRegionAgricoleLabel(Number(feature.get("ra_id")).toString());
};
var hideScaleBar = function () {
    var canvasLegend = document.getElementById("scalebar");
    canvasLegend.classList.add("d-none");
};
// /**
//  * Convert hsv colors to RGB based on https://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately
//  * @param {number} h - hue in [0, 360]
//  * @param {number} s - saturation in [0,1]
//  * @param {number} v - value in [0,1]
//  * @returns {number[]} r, g, b values in [0,1]
//  */
// const hsv2rgb = (h: number, s: number, v: number): number[] => {
//   let f = (n: number, k: number = (n + h / 60) % 6): number =>
//     v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
//   return [f(5), f(3), f(1)];
// };
/**
 * Populate base layers
 */
// const initWMSLayer = () => {
//   parcelsTileLayer = new Tile({
//     source: new TileWMS({
//       url: "https://geoservices.wallonie.be/arcgis/services/AGRICULTURE/SIGEC_PARC_AGRI_ANON__2018/MapServer/WMSServer?",
//       params: { LAYERS: "0,1,2", TILED: true },
//       serverType: "geoserver",
//       transition: 0,
//     }),
//     zIndex: 0,
//   });
//   baseTileLayer = new Tile({
//     source: new OSM(),
//     zIndex: 10,
//   });
//   baseSatTileLayer = new Tile({
//     source: new TileWMS({
//       url: "https://geoservices.wallonie.be/arcgis/services/IMAGERIE/ORTHO_2019/MapServer/WMSServer?",
//       params: { LAYERS: "0", TILED: true },
//       serverType: "geoserver",
//       transition: 0,
//     }),
//     zIndex: 0,
//   });
// };
/**
 * Create OpenLayer Map and populate it with data
 */
export var initMap = function () { return __awaiter(void 0, void 0, void 0, function () {
    var pextent, ZoomToExtentLabel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pextent = [221233, 6195895, 758987, 6793388];
                ZoomToExtentLabel = document.createElement("i");
                ZoomToExtentLabel.classList.add("fas", "fa-globe");
                map = new Map({
                    target: "map",
                    // layers: [baseTileLayer], // no base layer, only the regions
                    view: new View({
                        projection: "EPSG:3857",
                        center: transform([4.5, 50.2], "EPSG:4326", "EPSG:3857"),
                        zoom: 7,
                        extent: pextent,
                    }),
                    interactions: intdefaults({ mouseWheelZoom: false }),
                    controls: [],
                });
                map.addControl(new ExportToPngControl({ extent: pextent }));
                return [4 /*yield*/, initRegionAgricoleLayer()];
            case 1:
                _a.sent();
                return [2 /*return*/, map];
        }
    });
}); };
var initMapInteractions = function () {
    interactionSelect = new Select({
        layers: [raLayer],
        style: function (feature, resolution) {
            return getRegionAgricoleStyle(feature, resolution, true);
        },
        condition: function (e) { return selectCondition(e); },
    });
    interactionSelect
        .getFeatures()
        .on("add", function (e) { return displaySelectedFeature(e.element); });
    interactionSelect
        .getFeatures()
        .on("remove", function (e) { return onUnselectFeature(e.element); });
    map.addInteraction(interactionSelect);
    map.on("pointermove", function (e) {
        if (switchWms != null && switchWms.checked) {
            /* don't do anything if spatial variability is displayed */
            return;
        }
        else {
            /* FIXME still a problem when hover a ra title */
            resetPopup();
            map.forEachFeatureAtPixel(e.pixel, function (feature) { return openPopup(feature); });
        }
    });
};
/*
 * Add Region Agricole Layer
 */
var initRegionAgricoleLayer = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(BCGMS_API_URL, "ra/"))
                    .then(function (response) { return response.json(); })
                    .then(function (data) {
                    raSource = new VectorSource({});
                    raSource.addFeatures(new GeoJSON({
                        dataProjection: "EPSG:4326",
                        featureProjection: "EPSG:3857",
                    }).readFeatures(data));
                    loadDataForMapAndGraph(currentIndicator, true);
                    raLayer = new Vector({
                        source: raSource,
                        style: getRegionAgricoleStyle,
                        zIndex: 20,
                    });
                    raLayer.title = "Agricultural regions";
                    map.addLayer(raLayer);
                    initMapInteractions();
                    var max_iterra = data.features.length;
                    if (max_iterra < 1000000) {
                        for (var i = 0; i < max_iterra; i++) {
                            var ra = data.features[i];
                            REGIONS_AGRICOLES[ra.properties.ra_id] = ra.properties;
                        }
                    }
                    else {
                        console.log("Too many regions agricoles to display");
                    }
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/*
 * Select interaction
 */
var isFeatureSelected = function (feature) {
    var condition = false;
    interactionSelect.getFeatures().forEach(function (f) {
        if (feature === f) {
            condition = true;
        }
    });
    return condition;
};
/**
 * JPH Still need a separate data load for updateMapAndGraph
 */
export var loadDataForMap = function (indicator) {
    showLoaderBox();
    fetch(makeStatUrl(indicator, currentCrop.toString(), false)).then(function (response) {
        return response.json().then(function (statData) {
            fetch(makeIndicatorUrl(indicator, getCurrentYear().toString(), getCurrentDoy().toString(), currentCrop.toString()))
                .then(function (response) { return response.json(); })
                .then(function (data) {
                var indicatorCurrentYear = parseIndicatorResults(data.results);
                var indicatorStat = parseStatsResults(statData.results);
                makeMap(indicator, indicatorCurrentYear, indicatorStat);
                hideLoaderBox();
            });
        });
    });
};
/*
 * Returns a url to fetch data based on the indicator and the year given
 * @param {string} indicator - indicator name
 * @param {string} year - year, e.g., 2020
 * @param {string} doy - day-of-year, e.g., 34 (i.e., February, the 3rd)
 * @param {string} crop
 * @returns {string} url - A url for fetching data from the back-end
 */
export var makeIndicatorUrl = function (indicator, year, doy, crop) {
    var url = "";
    var indicator_params = INDICATORS_PARAMS[indicator];
    switch (indicator_params.provider) {
        case "RS":
            url = "".concat(BCGMS_API_URL, "vito/").concat(indicator, "/?doy=").concat(doy, "&year=").concat(year);
            break;
        case "IRM":
            url = "".concat(BCGMS_API_URL, "kmi-irm/").concat(indicator, "/").concat(doy, "?year=").concat(year);
            break;
        case "STATBEL":
            url = "".concat(BCGMS_API_URL, "statbel/").concat(indicator, "/").concat(crop, "/?year=").concat(year);
            break;
        case "FCST":
            url = "".concat(BCGMS_API_URL, "forecasts/").concat(indicator, "/").concat(crop, "/?year=").concat(year);
            break;
        default:
            url = url;
            break;
    }
    // console.log(`makeIndicatorUrl: ${url}`);
    return url;
};
/*
 * Make or update the map layer
 * @param {string} indicator - indicator name
 * @param {object} indicatorCurrentYear - object with the following properties
 *    - ra_id {number[]} - an array of the id of the region agricole
 *    - x {any[]} - an array of x data, e.g. an array of strings
 *    - y {number[]} - an array of y data, e.g, an array of numbers
 *    - q1 {number[]} - an array of the first quantile data
 *    - q3 {number[]} - an array of the third quantile data
 *    - name {string} - an array of label data, e.g., an array of strings
 * @param {object} statData
 */
export var makeMap = function (indicator, indicatorCurrentYear, statData) {
    if (statData === void 0) { statData = {}; }
    if (indicatorCurrentYear === undefined
    // ||    indicatorCurrentYear.x.length == 0
    ) {
        setMessageBox(gettext("Données non disponibles pour cette date / indicateur"));
        setStatusBox("");
        setInfoBox("");
        resetMap();
        hideScaleBar();
    }
    else if (indicatorCurrentYear.x.length == 0) {
        setMessageBox(gettext("Données non disponibles pour cette date / indicateur"));
        setStatusBox(statusContent());
        setInfoBox(getIndicatorDescription(indicator));
        resetMap();
        hideScaleBar();
    }
    else {
        setMessageBox("");
        resetCurrentMinMax();
        var values_1 = computeReferencialValues(indicatorCurrentYear.y, statData.normale);
        raSource.forEachFeature(function (feature) {
            var value = null;
            for (var i = 0; i <= indicatorCurrentYear.ra_id.length - 1; i++) {
                if (Number(indicatorCurrentYear.ra_id[i]) === Number(feature.get("ra_id"))) {
                    value = values_1[i] === null ? null : Number(values_1[i]);
                    if (currentMinValue === undefined || value < currentMinValue) {
                        currentMinValue = value;
                    }
                    if (currentMaxValue === undefined || value > currentMaxValue) {
                        currentMaxValue = value;
                    }
                    if (INDICATORS_PARAMS[indicator]["provider"] === "IRM") {
                        switch (currentReferencial) {
                            case "rel":
                                /** JPH tries to calculate relatives quartiles
                                 * based on what is done in graph_02.ts
                                 */
                                // feature.set(
                                //   "data_q1",
                                //   (-(statData.q1[i] - statData.normale[i]) /
                                //     statData.normale[i]) *
                                //     100
                                // );
                                // feature.set(
                                //   "data_q3",
                                //   ((statData.q3[i] - statData.normale[i]) /
                                //     statData.normale[i]) *
                                //     100
                                // );
                                feature.set("data_q1", "nan");
                                feature.set("data_q3", "nan");
                                break;
                            case "abs":
                                feature.set("data_q1", indicatorCurrentYear.q1[i]);
                                feature.set("data_q3", indicatorCurrentYear.q3[i]);
                                break;
                        }
                    }
                }
            }
            if (currentMinValue === 0 && currentMaxValue === 0) {
                // in case of null data
                resetCurrentMinMax();
            }
            feature.set("indicator", value);
        });
        setLegend(indicator, currentMinValue, currentMaxValue);
        showScaleBar();
        setReferenceDate(indicatorCurrentYear.refdate);
        setStatusBox(statusContent());
        setInfoBox(getIndicatorDescription(indicator));
    }
};
/*
 * Returns a url to fetch statistics data based on the indicator
 * @param {string} indicator - indicator name
 * @param {string} crop
 * @param {boolean} resetCalendar - to manage doy on initialisation = true
 * @returns {string} url - A url for fetching data from the back-end
 */
export var makeStatUrl = function (indicator, crop, resetCalendar) {
    if (resetCalendar === void 0) { resetCalendar = false; }
    var url = "";
    var indicator_params = INDICATORS_PARAMS[indicator];
    var ldoy = resetCalendar ? 0 : getCurrentDoy();
    switch (indicator_params.provider) {
        case "FCST":
            url = "".concat(BCGMS_API_URL, "forecasts/").concat(indicator, "/").concat(crop, "/stats/");
            break;
        case "IRM":
            url = "".concat(BCGMS_API_URL, "kmi-irm/").concat(indicator, "/stats/").concat(ldoy, "/");
            break;
        case "STATBEL":
            url = "".concat(BCGMS_API_URL, "statbel/").concat(indicator, "/").concat(crop, "/stats/?yearmin=").concat(getYearMin(), "&yearmax=").concat(getCurrentYear());
            break;
        case "RS":
            url = "".concat(BCGMS_API_URL, "vito/").concat(indicator, "/stats/?doy=").concat(getCurrentDoy());
            break;
        default:
            url = "";
            break;
    }
    return url;
};
var makeVitoWmsLayer = function (rsIndice, date) {
    var vito_layer = new Tile({
        source: new TileWMS({
            url: "https://maps.vito.be/geoserver/BCGMS/ows?service=wms&version=1.3.0&request=getcapabilities?",
            params: { LAYERS: "".concat(rsIndice, "_CROPPED_MASKED"), TILED: true, TIME: date },
        }),
        zIndex: 100,
    });
    vito_layer.setProperties({ title: "".concat(rsIndice, "_VITO_WMS") }, true);
    return vito_layer;
};
export var onSwitchWmsButton = function () {
    if (getCurrentProvider() === "RS") {
        if (switchWms.checked) {
            resetPopup();
            getSelectInteraction(map).setActive(false);
            getSelectInteraction(map).getFeatures().clear();
            addVitoWmsLayer(currentIndicator, referenceDate.toISOString());
            addLegendGraphicWms(currentIndicator);
            fadeOutRegionAgricolelayer();
        }
        else {
            resetWmsLayer();
        }
    }
};
var onUnselectFeature = function (_element) {
    setCurrentRa("");
    resetGeneralGraph();
};
var openPopup = function (feature) {
    var formatNumber = function (number) {
        var mynumber = Number.parseFloat(number);
        if (Math.abs(mynumber) < 1) {
            return mynumber.toFixed(3);
        }
        else if (Math.abs(mynumber) < 10) {
            return mynumber.toFixed(2);
        }
        else if (Math.abs(mynumber) < 100) {
            return mynumber.toFixed(1);
        }
        else {
            return mynumber.toFixed(0);
        }
    };
    popupContent.innerHTML = "";
    var popupTitle = document.createElement("div");
    popupTitle.classList.add("feature-properties");
    popupTitle.innerHTML = feature.get("name_" + curr_lang);
    popupContent.append(popupTitle);
    var popupValue = document.createElement("div");
    popupValue.classList.add("feature-properties");
    popupValue.innerHTML = "";
    if (INDICATORS_PARAMS[currentIndicator]["provider"] === "IRM") {
        popupValue.innerHTML = gettext("Valeur moyenne: ");
    }
    switch (currentReferencial) {
        case "rel":
            popupValue.innerHTML =
                popupValue.innerHTML + "".concat(formatNumber(feature.get("indicator")), " %");
            break;
        case "abs":
        default:
            popupValue.innerHTML =
                popupValue.innerHTML +
                    "".concat(formatNumber(feature.get("indicator")), " ").concat(INDICATORS_PARAMS[currentIndicator].unit, " <br />");
            break;
    }
    if (INDICATORS_PARAMS[currentIndicator]["provider"] === "IRM") {
        /** affichage des valeurs sous la carte */
        switch (currentReferencial) {
            case "rel":
                // comme on n'a que des NA, on n'affiche rien
                // popupValue.innerHTML =
                //   popupValue.innerHTML +
                //   " ( q1=" +
                //   `${formatNumber(feature.get("data_q1"))} %`;
                // popupValue.innerHTML =
                //   popupValue.innerHTML +
                //   ", q3=" +
                //   `${formatNumber(feature.get("data_q3"))} %` +
                //   " )";
                break;
            case "abs":
            default:
                popupValue.innerHTML =
                    popupValue.innerHTML +
                        " ( variabilité spatiale q1=" +
                        "".concat(formatNumber(feature.get("data_q1")), " ").concat(INDICATORS_PARAMS[currentIndicator].unit);
                popupValue.innerHTML =
                    popupValue.innerHTML +
                        ", q3=" +
                        "".concat(formatNumber(feature.get("data_q3")), " ").concat(INDICATORS_PARAMS[currentIndicator].unit) +
                        " )";
                break;
        }
    }
    popupContent.append(popupValue);
};
/*
 * Popups
 */
var popupContainer = document.getElementById("popup");
var popupContent = document.getElementById("popupContent");
var removeLegendGraphicWms = function () {
    var legendContainer = document.getElementById("scalebar-container");
    // const wmsLegend = legendContainer.getElementsByTagName('img');
    var wmsLegend = legendContainer.getElementsByClassName("vito-scale-wrapper");
    for (var _i = 0, _a = wmsLegend; _i < _a.length; _i++) {
        var e = _a[_i];
        //wmsLegend.removeChild(e);
        if (e.parentNode !== null) {
            e.parentNode.removeChild(e);
        }
    }
    legendContainer.classList.remove("vito-scale");
    showScaleBar();
    // const canvasLegend = document.getElementById("scalebar")!;
    // canvasLegend.classList.remove("d-none");
};
var resetMap = function () {
    // clear selected features
    getSelectInteraction(map).getFeatures().clear();
    // reset region agricole layer
    if (raSource !== undefined) {
        raSource.forEachFeature(function (f) { return f.set("indicator", undefined); });
    }
};
export var resetPopup = function () {
    popupContent.innerHTML = "";
};
export function resetCurrentMinMax() {
    // reset current min and max
    currentMinValue = undefined;
    currentMaxValue = undefined;
}
// function resetMapsZIndex() {
//   parcelsTileLayer.setZIndex(0);
//   baseTileLayer.setZIndex(10);
//   baseSatTileLayer.setZIndex(0);
//   classSelectedToBaseLayerButton(1);
// }
export var resetWmsLayer = function () {
    if (switchWms != null) {
        switchWms.checked = false;
    }
    getSelectInteraction(map).setActive(true);
    fadeInRegionAgricolelayer();
    removeVitoWmsLayers();
    removeLegendGraphicWms();
};
var removeVitoWmsLayers = function () {
    map.getLayers().forEach(function (l) {
        if (l !== undefined) {
            if (l.get("title") !== undefined) {
                if (l.get("title").includes("_VITO_WMS")) {
                    map.removeLayer(l);
                }
            }
        }
    });
};
// const selectCondition = (e: MapBrowserEvent) => {
var selectCondition = function (e) {
    var condition = false;
    if (e.type === "singleclick") {
        condition = true;
        map.forEachFeatureAtPixel(e.pixel, function (feature) {
            if (isFeatureSelected(feature)) {
                interactionSelect.getFeatures().clear();
                condition = false;
            }
        });
    }
    return condition;
};
/*
 * Set indicator legend
 * @param {string} indicator - indicator name
 */
var setLegend = function (indicator, min, max) {
    var _a, _b;
    if (min === void 0) { min = undefined; }
    if (max === void 0) { max = undefined; }
    var CANVAS_WIDTH = 100;
    var LEFT_MARGIN = 5;
    var LEGEND_WIDTH = 15;
    var LEFT_LABEL_MARGIN = LEFT_MARGIN + LEGEND_WIDTH + 5;
    var TOP_MARGIN = 5;
    var BAR_STEPS = 100;
    var BAR_STEP_HEIGHT = 2;
    var TICK_LENGTH = 4;
    var drawGraticuleY = function (ctx, yTick, x0, y0) {
        ctx.beginPath();
        ctx.moveTo(x0, y0 + yTick);
        ctx.lineTo(x0 - TICK_LENGTH, y0 + yTick);
        ctx.closePath();
        ctx.strokeStyle = "#424242";
        ctx.lineWidth = 1;
        ctx.stroke();
    };
    var legend = document.getElementById("scalebar");
    var ctx = legend.getContext("2d");
    if (ctx !== null) {
        ctx.canvas.height = BAR_STEPS * BAR_STEP_HEIGHT + TOP_MARGIN;
        ctx.canvas.width = CANVAS_WIDTH;
        ctx.canvas.getContext("2d").fillStyle = "rgba(255, 255, 255, 0.6)";
        ctx.canvas
            .getContext("2d")
            .fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        var minValue = (_a = setRoundedMinValue(min)) !== null && _a !== void 0 ? _a : INDICATORS_PARAMS[indicator].min_value;
        var maxValue = (_b = setRoundedMaxValue(max)) !== null && _b !== void 0 ? _b : INDICATORS_PARAMS[indicator].max_value;
        var unit = "";
        var palette = "";
        switch (currentReferencial) {
            case "rel":
                unit = "%";
                palette = "brown2green";
                break;
            case "abs":
            default:
                unit = INDICATORS_PARAMS[indicator].unit || "";
                palette = INDICATORS_PARAMS[currentIndicator].palette;
                break;
        }
        for (var i = 0; i <= BAR_STEPS; i++) {
            // colorbar
            var value = (i / BAR_STEPS) * (maxValue - minValue) + minValue;
            ctx.fillStyle = getColor(value, minValue, maxValue, palette);
            ctx.fillRect(LEFT_MARGIN, (BAR_STEPS - i) * BAR_STEP_HEIGHT + TOP_MARGIN, LEGEND_WIDTH, BAR_STEP_HEIGHT);
            // y-ticks
            if (i % 10 === 0) {
                drawGraticuleY(ctx, i * BAR_STEP_HEIGHT, LEFT_LABEL_MARGIN, TOP_MARGIN);
            }
        }
        // legend label
        ctx.fillStyle = "black";
        ctx.font = "12px arial";
        ctx.shadowColor = "white";
        ctx.shadowBlur = 4;
        ctx.fillStyle = "black";
        ctx.fillText("".concat(maxValue, " ").concat(unit), LEFT_LABEL_MARGIN, TOP_MARGIN + 10);
        ctx.fillText("".concat(minValue, " ").concat(unit), LEFT_LABEL_MARGIN, TOP_MARGIN + BAR_STEP_HEIGHT * BAR_STEPS - 5);
    }
};
var setRoundedMinValue = function (minValue) {
    return minValue === undefined
        ? undefined
        : minValue < 0
            ? Math.floor((minValue * 0.9) / 10) * 10
            : minValue < 1
                ? Math.floor(minValue * 0.9 * 10) / 10
                : minValue < 10
                    ? Math.floor(minValue * 0.9)
                    : minValue < 100
                        ? Math.floor((minValue * 0.9) / 10) * 10
                        : Math.floor((minValue * 0.9) / 100) * 100;
};
var setRoundedMaxValue = function (maxValue) {
    return maxValue === undefined
        ? undefined
        : maxValue < 0
            ? Math.ceil((maxValue * 1.1) / 10) * 10
            : maxValue < 1
                ? Math.ceil(maxValue * 1.1 * 10) / 10
                : maxValue < 10
                    ? Math.ceil(maxValue * 1.1)
                    : maxValue < 100
                        ? Math.ceil((maxValue * 1.1) / 10) * 10
                        : Math.ceil((maxValue * 1.1) / 100) * 100;
};
var showScaleBar = function () {
    var canvasLegend = document.getElementById("scalebar");
    canvasLegend.classList.remove("d-none");
};
